export default "__VITE_ASSET__CsyUdotN__"